import React, { Component } from 'react'
import {
    Card,
    Row,
    Col,
    Button,
    Input,
    Table
} from "reactstrap";
import LessonCard from "../LessonCard";

  
const ListItems = ({value, index }) => {
   return (
        <React.Fragment>
            <tr>
            <td style={{ backgroundColor: '#e6e7e8',  border: 0 }}><div className='author-lesson-checkbox side-checkbar'>
                                            <Input style={{ left: '28px', top: '-7px'}} type="checkbox" />
                                            <span class="checkmark"></span>
                                        </div></td>
                <td>{value.lessonName}</td>
                <td>{value.lessonCode}</td>
                <td>{value.section}</td>
                <td>{value.subcourse}</td>
                <td>{value.course}</td>
            </tr>
        </React.Fragment>
    )
   }


export default class AddSelectedItems extends Component {
    state = {
        dummyData: [],
        itemTableData: [],
        addItemCardData: [],
        items : [
            {
                lessonName : 'Puntuanation',
                lessonCode : 'punctuation-actm-e',
                section : ' Challenger-English',
                subcourse : 'ACT Mastery English',
                course : 'ACT Mastery'
            },
            {
                lessonName : 'Apostrophes',
                lessonCode : 'apostrophes-actm-e',
                section : ' Challenger-English',
                subcourse : 'ACT Mastery English',
                course : 'ACT Mastery'
            },
            {
                lessonName : 'Ambiguity and Series',
                lessonCode : 'ambiguity-and-series-actm-e',
                section : ' Challenger-English',
                subcourse : 'ACT Mastery English',
                course : 'ACT Mastery'
            }
        ]
    }
    componentDidMount() {
        
        this.setState(state => ({
            dummyData: state.items,
            itemTableData: state.items,
            addItemCardData: state.items
        }))
    }


  
    itemsFilter = (e, type) => {
        const { dummyData } = this.state

        e.target.value !== '' ?
            this.setState({
                [type]: dummyData.filter(val =>
                    val.itemCode.toLowerCase().search(e.target.value.toLowerCase()) !== -1)
            }) :
            this.setState({
                [type]: dummyData
            })

    }

  

    render() {
        const {
            itemTableData,
        } = this.state
     
        return (

            <Row>
                <Col className={`edit-lesson`} sm="12">
                    <LessonCard
                        iconClass="lesson-book"
                        heading="Add Selected Items to Lesson(s)"
                        isCollapsable
                        footerButtons={[
                            <Button onClick={()=> this.props.toggleRightCol('addSelectedItems')} className='lesson-cancel-btn'>Cancel Changes</Button>,
                            <Button className='lesson-action-btn'>Add Item to Lesson</Button>
                        ]}
                        >

                        <div className='filter-input'>
                            <Input onChange={e => this.itemsFilter(e, 'itemTableData')} type="text" name="filter-input" placeholder='Search' />
                        </div>
                        <div className='table-container'>
                           <div style={{ height : 'auto' , maxHeight: '300px' }} className='items-bank-left-container' >
                                <Table style={{ marginLeft: '-20px' }} striped hover className={`items-bank-table`}>
                                    <thead className='card-header'>
                                        <tr>
                                            <th style={{backgroundColor: '#e6e7e8', border: 0}} ></th>
                                            <th>Lesson Name</th>
                                            <th>Lesson Code</th>
                                            <th>Section</th>
                                            <th>Subcourse</th>
                                            <th>Course</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                   {itemTableData.map((value, index) => ( <ListItems value={value} index={index} />))}
                                   </tbody>      
                                </Table>
                            </div>
                        </div>
                    </LessonCard>
                </Col>
            </Row>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorItemsCards/AddSelectedItems.js